export default __webpack_public_path__ + "static/media/4.30f9fc3f.svg";